// app/products/page.tsx
import Link from "next/link";
import AppShell from "@/components/layout/AppShell";
import PageHeader from "@/components/ui/PageHeader";
import Button from "@/components/ui/Button";
import { TD, TH, THead } from "@/components/ui/Table";
import { store } from "@/lib/store";

export default function ProductsPage() {
    const products = store.getProducts();

    return (
        <AppShell>
            <PageHeader
                title="Products"
                description="Manage your dress catalog and variants."
                action={
                    <Link href="/products/new">
                        <Button>Add Product</Button>
                    </Link>
                }
            />

            <div className="rounded-2xl border border-rose-100 bg-white shadow-soft overflow-x-auto">
                <table className="min-w-full border-collapse">
                    <THead>
                        <tr>
                            <TH>Image</TH>
                            <TH>Name</TH>
                            <TH>SKU</TH>
                            <TH>Category</TH>
                            <TH>Origin</TH>
                            <TH>Status</TH>
                            <TH>Variants</TH>
                        </tr>
                    </THead>
                    <tbody>
                        {products.map((product) => (
                            <tr key={product.id} className="border-t border-rose-50">
                                <TD>
                                    <img
                                        src={product.coverImage}
                                        alt={product.name}
                                        className="h-16 w-12 rounded-lg object-cover"
                                    />
                                </TD>
                                <TD>{product.name}</TD>
                                <TD>{product.sku}</TD>
                                <TD>{product.category}</TD>
                                <TD>{product.sourceOrigin}</TD>
                                <TD>
                                    <span className="rounded-full bg-rose-50 px-3 py-1 text-xs font-semibold text-brand-700">
                                        {product.status}
                                    </span>
                                </TD>
                                <TD>{product.variants.length}</TD>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </AppShell>
    );
}